import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl } from 'core/http/lg-logistic-rest-api/api/api.service';
import { Observable } from 'rxjs';

@Injectable()
export class OrderCodeService {
  constructor(private http: HttpClient) {}

  generateOrderCode(filter: string): Observable<string> {
    return this.http.post<string>(apiUrl('/project/dev/get-order-code'), { orderFilter: filter }, { responseType: 'text' as 'json' });
  }
}
